// 富文本编辑器文档 https://www.kancloud.cn/liuwave/quill/1434140
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default VueQuillEditor